import styled, { css } from "styled-components"

const StyledContainer = styled.div`
  width: auto;
  height: 5.6rem;
  min-height: 5.6rem;
  display: flex;
  background: ${({ theme }) => theme.color.white};
  position: realtive;
  padding: 0.8rem 1.2rem;

  ${({ isActive }) =>
    isActive &&
    css`
      background: ${({ theme }) => theme.color.secondary05};
    `}
`
const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.2rem;
`
const StyledFirstLine = styled.div`
  display: flex;
  align-items: center;
`

const StyledIcon = styled.img`
  width: 3.2rem;
  height: 3.2rem;
  align-self: center;
`
const StyledName = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.secondary01};
  white-space: nowrap;
`
const StyledTraffic = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  line-height: 1.67;
  letter-spacing: 0.17px;
  color: ${({ theme }) => theme.color.secondary02};
`

export {
  StyledContainer,
  StyledContentContainer,
  StyledIcon,
  StyledName,
  StyledTraffic,
  StyledFirstLine,
}
